<template>
  <div class="cover" :style="{minHeight: clientHeight}">
    <nav-header
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showOrNot="p_showOrNot"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal">
    </nav-header>
    <div class="cover_in">
      <img class="banner banner-phone" src="../../assets/customs_banner_iphone_in.png" alt="">
      <img class="banner banner-pc" src="../../assets/customs_banner_pc_in.png" alt="">
      <div class="wrap">
        <div class="explain">
          <div class="explain_title">
            意义和作用：
          </div>
          <div class="explain_content">
            <p>随着疫情输入风险持续加大，需加强对入境人员的管控，进行新冠病毒核酸检测，保障国门安全</p>
          </div>
          <div class="explain_title">
            适用场景：
          </div>
          <div class="explain_content">
            <p>海关出入境管理</p>
          </div>
          <div class="explain_title">
            查看详情：
          </div>
          <div class="explain_content">
            <div class="process_btn" @click="toOrder">
              <p>点击查看 > </p>
            </div>
          </div>
          <div class="explain_title">
            操作流程：
          </div>
        </div>
        <div class="process">
          <div class="step">
            <img src="../../assets/customs_step.png" alt="">
            <p>1</p>
          </div>
          <div class="process_content">
            <div class="process_title">
              申请
            </div>
            <div class="process_intro">
              请咨询400 6057 800
            </div>
          </div>
        </div>
        <div class="process">
          <div class="step">
            <img src="../../assets/customs_step.png" alt="">
            <p>2</p>
          </div>
          <div class="process_content">
            <div class="process_title">
              送检
            </div>
            <div class="process_intro">
              根据生物安全二级防护标准（如穿戴一次性医用防护服、护目镜、双层手套、N95口罩、防护靴套等）进行送检
            </div>
          </div>
        </div>
        <div class="process">
          <div class="step">
            <img src="../../assets/customs_step.png" alt="">
            <p>3</p>
          </div>
          <div class="process_content">
            <div class="process_title">
              检测&报告
            </div>
            <div class="process_intro">
              由具备新冠病毒检测能力的机构检测并出具报告(最快当天可出)
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import NavHeader from "@/components/Header.vue";
  import {getCookie, removeHTMLTag} from "../../util/util"

  export default {
    name: "NovelCoronavirusSample",
    data() {
      return {
        clientHeight: 0,
        p_showSearch: true,
        p_loginModalFlag: false,
        p_showOrNot: 'not',
        sampleStatus: '0'
      }
    },
    computed: {

    },
    components: {
      NavHeader
    },
    mounted() {
      this.load()
      setTimeout(() => {
        this.clientHeight = document.documentElement.clientHeight + 'px'
      }, 100)
    },
    methods: {
      p_showLoginModal () {
        this.p_loginModalFlag = true;
      },

      p_closeLoginModal () {
        this.p_loginModalFlag = false;
      },
      load() {
        axios.get("/jys/questionnaire/xgStatus").then((res) => {
          this.sampleStatus = res.data.xgStatus
        })
      },
      toApply() {
        if (getCookie("_token")) {
          if (this.sampleStatus === '1') {
            this.$message.error('审核通过，无需填写')
          } else {
            this.$router.push({path: "/NovelCoronavirusApply"})
          }
        } else {
          window.scroll(0, 0)
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },
      toUpload() {
        if (getCookie("_token")) {
          if (this.sampleStatus === '1') {
            this.$message.error('审核通过，无需上传')
          } else {
            this.$router.push({path: "/NovelCoronavirusUpload"})
          }
        } else {
          window.scroll(0, 0)
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },
      toTemplate() {
        window.open('https://pic.jianyanwang.com/upload/20200227/78e1a4b01d8c4a79b31c55e9908ae04f.zip')
      },
      toOrder() {
        this.$router.push({
          path: "detection",
          query: {id: '382', remark: ''}
        })
      }
    }
  }
</script>

<style scoped>
  .cover{
    width: 100%;
    float: left;
    background-color: #5d80fc;
  }
  .cover_in{
    width: 100%;
    margin: 0 auto;
  }
  .cover .banner{
    width: 100%;
    float: left;
  }
  .wrap{
    float: left;
    margin: 40px 30px;
    border-radius: 10px;
    background-color: #ffffff;
  }
  .explain{
    float: left;
    padding: 30px;
    box-sizing: border-box;
    color: #131313;
    font-size: 13px;
  }
  .explain_title,
  .explain_content{
    width: 100%;
    float: left;
  }
  .explain_title{
    font-weight: bolder;
    padding-left: 10px;
    border-left: 3px solid #5d80fc;
  }
  .explain_content{
    padding: 10px 0 25px 13px;
  }
  .process{
    float: left;
    margin: 0 40px;
    padding: 20px 0;
    box-sizing: border-box;
    color: #888888;
    font-size: 13px;
    position: relative;
    border-left: 3px solid #5d80fc;
  }
  .step{
    position: absolute;
    top: 15px;
    left: -15px;
  }
  .process_content{
    float: left;
    margin: 0 0 0 35px;
  }
  .step img{
    width: 34px;
    height: 25px;
  }
  .step p{
    position: absolute;
    top: 3px;
    left: 10px;
    color: #ffffff;
  }
  .process_title{
    color: #5d80fc;
    font-weight: bolder;
    margin-bottom: 10px;
  }
  .process_intro{
    font-size: 12px;
    margin-bottom: 10px;
  }
  .process_btn{
    width: 100px;
    float: left;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    background-color: #5d80fc;
    cursor: pointer;
  }
  .template{
    margin-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    color: #108EE9;
    text-decoration: underline;
    cursor: pointer;
  }
  .process_code {
    width: 80px;
    height: 80px;
    text-align: center;
    font-size: 12px;
  }
  .process_code img{
    width: 100%;
  }
  .process:last-child{
    margin-bottom: 50px;
  }
  .banner-phone{
    display: block;
  }
  .banner-pc{
    display: none;
  }
  @media only screen and (min-width: 600px) {
    .banner-phone{
      display: none;
    }
    .banner-pc{
      display: block;
    }
    .cover_in{
      width: 45%;
    }
    .step{
      top: 35px;
    }
    .process{
      width: 100%;
      padding: 40px 0;
    }
    .explain{
      padding-bottom: 50px;
    }
    .explain_content{
      padding-bottom: 50px;
    }
    .process_code{
      width: 100px;
      height: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/activities/novel-coronavirus-customs.vue